import React, {useEffect, useRef, useState} from 'react';

import ReactPlayer from 'react-player';
import styles from "./homeMovies2.module.scss";
import useTranslation from 'next-translate/useTranslation'

const Movies = () => {

    const {t, lang} = useTranslation()
    const isRTL = lang === 'farsi';

    const [selected, setSelected] = useState(null)
    const [isDesktop, setIsDesktop] = useState(false);

    const data = [
        {
            src: '/videos/intro.mp4',
            title: 'Top Konkoor Students Use WoW',
            titleFa: 'دانش‌آموزان برتر کنکور از دنیای واژه‌ها استفاده میکنند',
            subTitle: '',
            subTitleFa: '',
            thumbnail: '/images/videoThumbnail/video1.jpg'
        },
        {
            src: '/videos/summerFestival.mp4',
            title: 'Summer English Festival',
            titleFa: 'جشنواره تابستانی زبان انگلیسی',
            subTitle: 'Here, You can see how WoW has evolved in Kanoon Farhangi Amoozesh',
            subTitleFa: 'اینجا میتوانید ببینید دنیای واژه‌ها چگونه در کانون فرهنگی آموزش رشد کرده',
            thumbnail: '/images/videoThumbnail/video2.jpg'
        },
        {
            src: '/videos/Final_wow.mp4',
            title: 'Learn English in World of Words',
            titleFa: 'در دنیای واژه‌ها انگلیسی بیاموزید',
            subTitle: 'Let\'s Play',
            subTitleFa: 'بیایید بازی کنیم',
            thumbnail: '/images/videoThumbnail/video3.jpg'
        },
        {
            src: '/videos/wowIntroM.mp4',
            title: 'Introduction to World of Words',
            titleFa: 'معرفی وبسایت دنیای واژه‌ها',
            subTitle: 'By one of our users',
            subTitleFa: 'توسط یکی از کاربران',
            thumbnail: '/images/videoThumbnail/wowIntroThumbnail.png'
        }
    ]

    useEffect(() => {
        setSelected(data[1]);
    }, [])

    useEffect(() => {
        if (window?.screen?.width > 999) {
            setIsDesktop(true)
        }
    }, [])

    const handleSelect = (src) => {
        setSelected(src)
    }

    const playerRef = useRef();
    const [playerState, setPlayerState] = useState({
        playing: true,
    })

    return (
        <div className={styles.wrapper}>
            <div className={styles.container} style={{direction: isRTL ? 'rtl' : 'ltr', textAlign: isRTL ? 'right' : ''}}>
                <div className={styles.title}>
                    <h2 className={styles.moviesTitle}>
                        {t('home:woWHistory')}
                    </h2>
                    <div className={styles.movies}>
                        <div className={`${styles.mainMovie} ${styles.showOnDesktop}`}>
                            <div className={styles.mainMovieImage}>
                                <ReactPlayer
                                    url={selected && selected.src}
                                    width='100%'
                                    height='100%'
                                    playing={playerState.playing}
                                    ref={playerRef}
                                    controls
                                    light={selected && selected.thumbnail}
                                    config={{
                                        file: {
                                            attributes: {
                                                controlsList: `nodownload ${isDesktop ? '' : 'nofullscreen'}`
                                            }
                                        }
                                    }}
                                />
                            </div>
                            <div className={styles.mainDescriptionWrapper}>
                                <h4 className={styles.mainLargeDescription}>{selected && (isRTL ? selected.titleFa : selected.title)}</h4>
                                <p className={styles.mainSmallDescription}>{selected && (isRTL ? selected.subTitleFa : selected.subTitle)}</p>
                            </div>
                        </div>
                        <div className={styles.sideMovies}>
                            <div className={styles.sideMovieWrapper}
                                 onClick={() => handleSelect(data[0])}
                            >
                                <div className={styles.sideMovieImage}>
                                    <ReactPlayer
                                        className={styles.showOnMobile}
                                        light={data && data[0]?.thumbnail}
                                        url={data && data[0]?.src}
                                        width='100%'
                                        height='100%'
                                        controls
                                        config={{
                                            file: {
                                                attributes: {
                                                    controlsList: `nodownload ${isDesktop ? '' : 'nofullscreen'}`
                                                }
                                            }
                                        }}
                                    />
                                    <img className={styles.showOnDesktop} src={'/images/videoThumbnail/video1.jpg'}/>
                                </div>
                                <div className={styles.decriptionWrapper}>
                                    <h4 className={styles.largeDescription}>{isRTL ? data[0].titleFa : data[0].title}</h4>
                                    {/*<p className={styles.smallDescription}>LET'S PLAY</p>*/}
                                </div>
                            </div>
                            <div className={styles.sideMovieWrapper}
                                 onClick={() => handleSelect(data[1])}
                            >

                                <div className={styles.sideMovieImage}>
                                    <ReactPlayer
                                        className={styles.showOnMobile}
                                        light={data && data[1]?.thumbnail}
                                        url={data && data[1]?.src}
                                        width='100%'
                                        height='100%'
                                        controls
                                        config={{
                                            file: {
                                                attributes: {
                                                    controlsList: `nodownload ${isDesktop ? '' : 'nofullscreen'}`
                                                }
                                            }
                                        }}
                                    />
                                    <img className={styles.showOnDesktop} src={'/images/videoThumbnail/video2.jpg'}/>
                                </div>
                                <div className={styles.decriptionWrapper}>
                                    <h4 className={styles.largeDescription}>{isRTL ? data[1].titleFa : data[1].title}</h4>
                                    <p className={styles.smallDescription}>
                                        {isRTL ? data[1].subTitleFa : data[1].subTitle}</p>
                                </div>
                            </div>
                            <div className={styles.sideMovieWrapper}
                                 onClick={() => handleSelect(data[2])}
                            >

                                <div className={styles.sideMovieImage}>
                                    <ReactPlayer
                                        className={styles.showOnMobile}
                                        light={data && data[2].thumbnail}
                                        url={data && data[2]?.src}
                                        width='100%'
                                        height='100%'
                                        controls
                                        config={{
                                            file: {
                                                attributes: {
                                                    controlsList: `nodownload ${isDesktop ? '' : 'nofullscreen'}`
                                                }
                                            }
                                        }}
                                    />
                                    <img className={styles.showOnDesktop} src={'/images/videoThumbnail/video3.jpg'}/>
                                </div>
                                <div className={styles.decriptionWrapper}>
                                    <h4 className={styles.largeDescription}>{isRTL ? data[2].titleFa : data[2].title}</h4>
                                    <p className={styles.smallDescription}>
                                        {isRTL ? data[2].subTitleFa : data[2].subTitle}</p>
                                </div>
                            </div>
                            <div className={styles.sideMovieWrapper}
                                 onClick={() => handleSelect(data[3])}
                            >
                                <div className={styles.sideMovieImage}>
                                    <ReactPlayer
                                        className={styles.showOnMobile}
                                        light={data && data[3].thumbnail}
                                        url={data && data[3]?.src}
                                        width='100%'
                                        height='100%'
                                        controls
                                        config={{
                                            file: {
                                                attributes: {
                                                    controlsList: `nodownload ${isDesktop ? '' : 'nofullscreen'}`
                                                }
                                            }
                                        }}
                                    />
                                    <img className={styles.showOnDesktop}
                                         src={'/images/videoThumbnail/wowIntroThumbnail.png'}/>
                                </div>
                                <div className={styles.decriptionWrapper}>
                                    <h4 className={styles.largeDescription}>{isRTL ? data[3].titleFa : data[3].title}</h4>
                                    <p className={styles.smallDescription}>
                                        {isRTL ? data[3].subTitleFa : data[3].subTitle}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
export default Movies;